<template>
	<Col>
		<SharedEveryoneGroup
			v-if="isWorkflowSharedWithEveryone"
			:workflow="workflow"
			:usersSharedData="usersSharedData"
			:groupsSharedData="groupsSharedData"
			:hideVisibilityStatus="hideVisibilityStatus"
		/>
		<SharedUsers
			:workflow="workflow"
			:sharedData="usersSharedData"
			:users="membersAlreadySharedWith"
			:hideVisibilityStatus="hideVisibilityStatus"
		/>
		<SharedGroups
			:workflow="workflow"
			:sharedData="groupsSharedData"
			:groups="groupsAlreadySharedWith"
			:usersSharedData="usersSharedData"
			:hideVisibilityStatus="hideVisibilityStatus"
		/>
	</Col>
</template>

<script>
import WorkflowService from '@/utils/WorkflowService';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { teamMembers } from '@/store/modules/account/getters';
import { groups } from '@/store/modules/accountGroups/getters';
import SharedUsers from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedUsers.vue';
import SharedGroups from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedGroups.vue';
import { getWorkflow, workflowSharedData, workflowSharedDataLoading } from '@/store/modules/workflows/getters';
import SharedEveryoneGroup from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedEveryoneGroup.vue';
import { WorkflowAccessType } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'ExistingShareList',
	components: {
		SharedUsers,
		SharedGroups,
		SharedEveryoneGroup,
	},
	props: {
		workflow: { type: Object },
	},
	computed: {
		...mapGettersShorthand({ groups, teamMembers, getWorkflow, workflowSharedData, workflowSharedDataLoading }),
		hideVisibilityStatus() {
			return !this.isAddOn;
		},
		isAddOn() {
			return WorkflowService.isOfTypeFeature(this.workflow);
		},
		sharedWorkflowData() {
			return this.workflowSharedData(this.workflow.id) || {};
		},
		isWorkflowSharedWithEveryone() {
			return this.workflow.access_type === WorkflowAccessType.WorkspaceUsers;
		},
		personalSetup() {
			return this.sharedWorkflowData.personal_setup || {};
		},
		personalSetupResponses() {
			return this.personalSetup.responses || [];
		},
		doesFeatureRequirePersonalSetup() {
			return this.personalSetup.has_required_fields || false;
		},
		usersSharedData() {
			const res = (this.sharedWorkflowData.user_settings || []).map((userSettings) => {
				const user = this.sharedWorkflowData.shared_users.find((u) => u.id === userSettings.user_id) || {};
				const id = user?.id || userSettings.user_id;
				return { ...user, id, is_on: userSettings.is_on || false, is_setup_required: this.getUserIsSetupRequired(id) };
			});
			return res;
		},
		groupsSharedData() {
			const res = (this.sharedWorkflowData.group_settings || []).map((groupSettings) => {
				const group = this.sharedWorkflowData.shared_groups.find((gr) => gr.id === groupSettings.group_id) || {};
				const id = group?.id || groupSettings.group_id;
				return { ...group, id, is_on: groupSettings.is_on || false };
			});
			return res;
		},
		membersAlreadySharedWith() {
			return this.teamMembers.filter((u) => (this.sharedWorkflowData.shared_users || []).map((user) => user.id).includes(u.user_id));
		},
		groupsAlreadySharedWith() {
			return this.groups.filter((g) => (this.sharedWorkflowData.shared_groups || []).map((group) => group.id).includes(Number(g.id)));
		},
	},
	methods: {
		getUserIsSetupRequired(userId) {
			if (!this.doesFeatureRequirePersonalSetup) {
				// Feature does not require setup
				return false;
			}
			const userPersonalResponse = this.personalSetupResponses.find(({ user_id }) => user_id === userId);
			if (!userPersonalResponse) {
				// User has not responded yet
				return true;
			}
			return !userPersonalResponse.is_completed;
		},
	},
};
</script>

<style scoped lang="scss">
::v-deep {
	.share-list-item {
		margin-bottom: 8px;
		padding-left: 12px;
		padding-right: 12px;
	}
}
</style>
